enum ReadyState {
  'PENDING' = 'pending',
  'LOADING' = 'loading',
  'REJECTED' = 'rejected',
  'FULFILLED' = 'fulfilled',
}

export default ReadyState;
